module.exports = __webpack_public_path__ + "static/media/F2.889e3060.jpg";